import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApplicationMenu } from '../types/menu';

@Injectable()
export class MenuService {
  menuItems = new BehaviorSubject<ApplicationMenu[]>([]);
  menuItemSelectedId = new BehaviorSubject<number>(-1);

  menuClick = new EventEmitter<number>();

  constructor() {}
}
